import { PRICE_URL } from '../../CONSTANTS';

import { callGetAxios, callPostAxios, callPutAxios } from '../common/common';

export const getPriceList = (data) => {
    return callPostAxios(PRICE_URL() + 'getAllRecords', data, 'getPriceList');
};

export const getPriceDetails = (id) => {
    return callGetAxios(PRICE_URL() + id, 'getPriceDetails');
};

export const addPrice = (data) => {
    return callPostAxios(PRICE_URL(), data, 'addPrice');
};

export const getPriceKeyValuePair = (id) => {
    return callGetAxios(PRICE_URL() + 'sales/getKeyValueList', 'getItemDetail');
};

export const getSalesPriceKeyValuePair = (id) => {
    return callGetAxios(PRICE_URL() + 'sales/getKeyValueList', 'getItemDetail');
};

export const getPurchasePriceKeyValuePair = (id) => {
    return callGetAxios(PRICE_URL() + 'purchase/getKeyValueList', 'getItemDetail');
};

export const activeDeactivePrice = (id) => {
    return callPutAxios(PRICE_URL() + 'activeOrDeActiveItemPriseList/' + id, id, 'activeDeactivePrice');
};

export const updatePrice = (id, data) => {
    return callPutAxios(PRICE_URL() + id, data, 'updatePrice');
};

export const testUpdatePrice = (id, data) => {
    return callPutAxios(PRICE_URL() + 'bulk/' + id, data, 'testUpdatePrice');
};
export const getRecordsBySearch = (data) => {
    return callPostAxios(PRICE_URL() + "getRecordsBySearch", data, 'itemList');
};

export const getPriceListByOrganizationId = (data) => {
    return callPostAxios(PRICE_URL() + "getPriceListByOrganisationId", data, 'priceList');
};

export const getSyncedPriceListByOrganizationId = (data) => {
    return callPostAxios(PRICE_URL() + "getSyncedPriceListByOrganisationId", data, 'priceList');
};
export const proceedToSyncPrices = (data) => {
    return callPostAxios(PRICE_URL() + "syncPrices", data, 'priceList');
};

export const itemPriceListReport = (data) => {
    return callPostAxios(PRICE_URL() + "itemPriceListReport", data, 'Item Price List Report');
};
export const itemMultiPriceListReport = (data) => {
    return callPostAxios(PRICE_URL() + "addMultipleItemsForMultiplePriceList", data, "Item Multi Price List Report");
};

export const downloadItemPriceExcel = (id) => {
    return callGetAxios(PRICE_URL() + "downloadItemPriceExcel/" + id, "downloadItemPriceExcel");
};

export const uploadItemPriceExcel = (id, data) => {
    return callPostAxios(PRICE_URL() + "uploadItemPriceExcel/" + id, data, "uploadItemPriceExcel");
};
